{
	"es": {
		"caps_now": "AHORA",
		"uploading": "Subiendo...",
		"wait_for_upload": "Esperando la subida de las imágenes ([0])",
		"upload_complete": "Carga completa",
		"n_selected": "[0] seleccionado",
		"1_selected": "1 seleccionado",
		"drag_to_sort": "Arrastra para ordenar",
		"add_item": "Añadir artículo",
		"save": "Salvar",
		"select_placeholder": "Seleccionar",
		"read_the_contract": "leer el contrato",
		"accept_contract": "Aceptar contrato",
		"read_more": "Leer más...",
		"accept_general_conditions": "Aceptar el contrato antes de continuar",
		"confirm": "Confirmar",
		"cancel": "Cancelar",
		"copied": "¡Copiado!",
		"erase_filters": "Filtros",
		"rating_1": "Pobre",
		"rating_2": "Justo",
		"rating_3": "Bien",
		"rating_4": "Muy bien",
		"rating_5": "Excelente",
		"forecast_delivery": "Entrega programada [0]",
		"forecast_preparation": "Tu pedido estará listo [0]",
		"last_24_hours": "Últimas 24 horas",
		"last_7_days": "Los últimos 7 días",
		"last_30_days": "últimos 30 días",
		"last_365_days": "Últimos 365 días",
		"generic_error": "Ocurrió un error. Inténtelo de nuevo o comuníquese con el soporte.",
		"counter": "Punto de venta",
		"volume_types_chart": "Volumen de negocio por medio de pago",
		"orders_types_chart": "Pedidos por forma de pago",
		"volume_mode_chart": "Volumen de negocio por tipo de pedido",
		"orders_mode_chart": "Pedidos por tipo de pedido",
		"card_network_volume": "Volumen de negocio por circuito de tarjetas",
		"card_network_orders": "Pedidos por circuito de tarjetas",
		"card_funding_volume": "Volumen de negocio por tipo de tarjetas",
		"card_funding_orders": "Pedido por tipo de tarjeta",
		"multi_payment": "Pago múltiple",
		"failed_invoice": "No se pudo generar la factura",
		"allergens_filter": "Filtro de alérgenos",
		"menu": "Menú",
		"catalog": "Catalogar",
		"wire": "Transferencia bancaria",
		"check": "Controlar",
		"ticket": "Boleto",
		"paylater": "Paga después",
		"week_letter": "w",
		"1_week": "1 semana",
		"4_weeks": "4 semanas",
		"this_month": "Mes actual",
		"delivery": "Entrega",
		"takeaway": "Para llevar",
		"delivery_other": "Entrega",
		"takeaway_other": "Levantar",
		"3_months": "3 meses",
		"6_months": "6 meses",
		"1_year": "1 año",
		"this_year": "Año corriente",
		"soon": "pronto",
		"x_min": "[0] minutos",
		"x_min_ago": "[0] hace minutos",
		"x_hours": "[0] horas",
		"x_hours_ago": "[0] hace horas",
		"x_days": "[0] días",
		"x_days_ago": "[0] días atrás",
		"in_x_min": "en [0] minutos",
		"in_x_hour": "en [0] horas",
		"today_at": "hoy en [0]",
		"tomorrow_at": "mañana a las [0]",
		"in_x_days": "en [0] días",
		"in_1_hour_x_min": "en 1 hora y [0] min",
		"in_x_hours_y_min": "en [0] horas y [1] min",
		"total_pagination": "Total: [0]",
		"business_is_subscribed": "Negocio ya suscrito",
		"restaurant": "Restaurante",
		"bar": "Bar o pub",
		"beach": "Resort Playa",
		"other": "Otro",
		"ok": "Ok",
		"copy": "Copiar",
		"apply": "Aplicar",
		"back": "Atrás",
		"items_per_page": "Artículos por página",
		"next": "Próximo",
		"success": "Éxito",
		"operation_completed": "Operación completada",
		"action": "Acción",
		"error": "Error",
		"room": "Sala",
		"warning": "Advertencia",
		"no_result": "Sin resultados",
		"total_x": "Total: [0]",
		"missing_data": "Datos no disponibles.",
		"allergens_celery": "Apio",
		"allergens_clams": "Almejas",
		"allergens_dioxide": "sulfitos",
		"allergens_egg": "Huevo",
		"allergens_fish": "Pez",
		"allergens_lupins": "altramuces",
		"allergens_gluten": "Gluten",
		"allergens_milk": "Leche",
		"allergens_mustard": "Mostaza",
		"allergens_peanuts": "Miseria",
		"allergens_sesame": "Sésamo",
		"allergens_shellfish": "Mariscos",
		"allergens_soia": "Soja",
		"allergens_wot": "Nueces",
		"allergens_almond": "Almendras",
		"allergens_barley": "Cebada",
		"allergens_brazil_nuts": "nueces brasileñas",
		"allergens_cashew": "Anacardo",
		"allergens_hazelnuts": "Avellanas",
		"allergens_macadamia": "macadamia",
		"allergens_oats": "Avena",
		"allergens_pecan": "Pacana",
		"allergens_pistachios": "pistachos",
		"allergens_rye": "Centeno",
		"allergens_spelt": "Espelta",
		"allergens_walnuts": "nueces",
		"allergens_wheat": "Trigo",
		"allergens_alcohol": "Alcohol",
		"allergens_halal": "halal",
		"allergens_kosher": "Comestible según la ley judía",
		"allergens_vegan": "Vegano",
		"allergens_vegetarian": "Vegetariano",
		"allergens_no_allergens": "Sin alérgenos",
		"allergens_gluten_free": "Sin gluten",
		"allergens_kamut": "kamut",
		"try_later_error": "Se ha producido un error. Por favor, inténtelo de nuevo más tarde.",
		"saved": "Salvado",
		"changes_saved": "Los cambios se guardaron exitosamente",
		"no": "No",
		"yes": "Sí"
	},
	"fr": {
		"caps_now": "MAINTENANT",
		"uploading": "Téléchargement...",
		"wait_for_upload": "En attente du téléchargement des images ([0])",
		"upload_complete": "Téléchargement complet",
		"n_selected": "[0] sélectionné",
		"1_selected": "1 sélectionné",
		"drag_to_sort": "Faites glisser pour trier",
		"add_item": "Ajouter un item",
		"save": "Sauvegarder",
		"select_placeholder": "Sélectionner",
		"read_the_contract": "Lire le contrat",
		"accept_contract": "Accepter le contrat",
		"read_more": "En savoir plus...",
		"accept_general_conditions": "Acceptez le contrat avant de continuer",
		"confirm": "Confirmer",
		"cancel": "Annuler",
		"copied": "Copié!",
		"erase_filters": "Filtres",
		"rating_1": "Pauvre",
		"rating_2": "Équitable",
		"rating_3": "Bien",
		"rating_4": "Très bien",
		"rating_5": "Excellent",
		"forecast_delivery": "Livraison programmée [0]",
		"forecast_preparation": "Votre commande sera prête [0]",
		"last_24_hours": "Dernières 24 heures",
		"last_7_days": "Les 7 derniers jours",
		"last_30_days": "Les 30 derniers jours",
		"last_365_days": "365 derniers jours",
		"generic_error": "Une erreur s'est produite. Réessayez ou contactez l'assistance.",
		"counter": "Point de vente",
		"volume_types_chart": "Volume par mode de paiement",
		"orders_types_chart": "Commandes par mode de paiement",
		"volume_mode_chart": "Volume par mode de commande",
		"orders_mode_chart": "Commandes par mode de commande",
		"card_network_volume": "Volume du réseau de la carte",
		"card_network_orders": "Commandes de réseaux de cartes",
		"card_funding_volume": "Volume de financement par carte",
		"card_funding_orders": "Ordres de financement par carte",
		"multi_payment": "Paiement multiple",
		"failed_invoice": "Échec de la génération de la facture",
		"allergens_filter": "Filtre allergènes",
		"menu": "Menu",
		"catalog": "Catalogue",
		"wire": "Virement bancaire",
		"check": "Vérifier",
		"ticket": "Billet",
		"paylater": "Payer plus tard",
		"week_letter": "w",
		"1_week": "1 semaine",
		"4_weeks": "4 semaines",
		"this_month": "Mois en cours",
		"delivery": "Livraison",
		"takeaway": "Emporter",
		"delivery_other": "Livraison",
		"takeaway_other": "Ramasser",
		"3_months": "3 mois",
		"6_months": "6 mois",
		"1_year": "1 an",
		"this_year": "Année actuelle",
		"soon": "bientôt",
		"x_min": "[0] minutes",
		"x_min_ago": "il y a [0] minutes",
		"x_hours": "[0] heures",
		"x_hours_ago": "il y a [0] heures",
		"x_days": "[0] jours",
		"x_days_ago": "il y a [0] jours",
		"in_x_min": "dans [0] minutes",
		"in_x_hour": "dans [0] heures",
		"today_at": "aujourd'hui à [0]",
		"tomorrow_at": "demain à [0]",
		"in_x_days": "dans [0] jours",
		"in_1_hour_x_min": "dans 1 heure et [0] min",
		"in_x_hours_y_min": "dans [0] heures et [1] min",
		"total_pagination": "Total : [0]",
		"business_is_subscribed": "Entreprise déjà abonnée",
		"restaurant": "Restaurant",
		"bar": "Bar ou Pub",
		"beach": "Plage du complexe",
		"other": "Autre",
		"ok": "D'accord",
		"copy": "Copie",
		"apply": "Appliquer",
		"back": "Dos",
		"items_per_page": "objets par page",
		"next": "Suivant",
		"success": "Succès",
		"operation_completed": "Opération terminée",
		"action": "Action",
		"error": "Erreur",
		"room": "Sala",
		"warning": "Avertissement",
		"no_result": "Pas de résultat",
		"total_x": "Total : [0]",
		"missing_data": "Pas de données disponibles.",
		"allergens_celery": "Céleri",
		"allergens_clams": "Palourdes",
		"allergens_dioxide": "Sulfites",
		"allergens_egg": "Œuf",
		"allergens_fish": "Poisson",
		"allergens_lupins": "Lupins",
		"allergens_gluten": "Gluten",
		"allergens_milk": "Lait",
		"allergens_mustard": "Moutarde",
		"allergens_peanuts": "Cacahuètes",
		"allergens_sesame": "Sésame",
		"allergens_shellfish": "Fruits de mer",
		"allergens_soia": "Soja",
		"allergens_wot": "Des noisettes",
		"allergens_almond": "Amandes",
		"allergens_barley": "Orge",
		"allergens_brazil_nuts": "Noix du Brésil",
		"allergens_cashew": "Anacardier",
		"allergens_hazelnuts": "Noisettes",
		"allergens_macadamia": "Macadamia",
		"allergens_oats": "Avoine",
		"allergens_pecan": "Noix de pécan",
		"allergens_pistachios": "Pistaches",
		"allergens_rye": "Seigle",
		"allergens_spelt": "Orthographié",
		"allergens_walnuts": "Noix",
		"allergens_wheat": "Blé",
		"allergens_alcohol": "Alcool",
		"allergens_halal": "Halal",
		"allergens_kosher": "Kascher",
		"allergens_vegan": "Végétalien",
		"allergens_vegetarian": "Végétarien",
		"allergens_no_allergens": "Aucun allergène",
		"allergens_gluten_free": "Sans gluten",
		"allergens_kamut": "Kamout",
		"try_later_error": "Une erreur est survenue. Veuillez réessayer plus tard.",
		"saved": "Enregistré",
		"changes_saved": "Changements sauvegardés avec succès",
		"no": "Non",
		"yes": "Oui"
	},
	"de": {
		"caps_now": "JETZT",
		"uploading": "Hochladen...",
		"wait_for_upload": "Warten auf den Upload der Bilder ([0])",
		"upload_complete": "Hochladen abgeschlossen",
		"n_selected": "[0] ausgewählt",
		"1_selected": "1 ausgewählt",
		"drag_to_sort": "Zum Sortieren ziehen",
		"add_item": "Artikel hinzufügen",
		"save": "Speichern",
		"select_placeholder": "Wählen",
		"read_the_contract": "Lesen Sie den Vertrag",
		"accept_contract": "Vertrag annehmen",
		"read_more": "Mehr lesen...",
		"accept_general_conditions": "Akzeptieren Sie den Vertrag, bevor Sie fortfahren",
		"confirm": "Bestätigen",
		"cancel": "Stornieren",
		"copied": "Kopiert!",
		"erase_filters": "Filter",
		"rating_1": "Arm",
		"rating_2": "Gerecht",
		"rating_3": "Gut",
		"rating_4": "Sehr gut",
		"rating_5": "Exzellent",
		"forecast_delivery": "Geplante Lieferung [0]",
		"forecast_preparation": "Ihre Bestellung ist fertig [0]",
		"last_24_hours": "Letzte 24 Stunden",
		"last_7_days": "Letzten 7 Tage",
		"last_30_days": "Letzte 30 Tage",
		"last_365_days": "Letzte 365 Tage",
		"generic_error": "Ein Fehler ist aufgetreten. Versuchen Sie es erneut oder wenden Sie sich an den Support.",
		"counter": "Kasse",
		"volume_types_chart": "Volumen pro Zahlungsmethode",
		"orders_types_chart": "Bestellungen pro Zahlungsart",
		"volume_mode_chart": "Volumen pro Bestellmodus",
		"orders_mode_chart": "Bestellungen pro Bestellmodus",
		"card_network_volume": "Kartennetzwerkvolumen",
		"card_network_orders": "Kartennetzwerkbestellungen",
		"card_funding_volume": "Kartenfinanzierungsvolumen",
		"card_funding_orders": "Kartenfinanzierungsaufträge",
		"multi_payment": "Mehrfachzahlung",
		"failed_invoice": "Rechnung konnte nicht erstellt werden",
		"allergens_filter": "Allergenfilter",
		"menu": "Speisekarte",
		"catalog": "Katalog",
		"wire": "Banküberweisung",
		"check": "Überprüfen",
		"ticket": "Fahrkarte",
		"paylater": "Später bezahlen",
		"week_letter": "w",
		"1_week": "1 Woche",
		"4_weeks": "4 Wochen",
		"this_month": "Aktueller Monat",
		"delivery": "Lieferung",
		"takeaway": "Wegbringen",
		"delivery_other": "Lieferung",
		"takeaway_other": "Abholen",
		"3_months": "3 Monate",
		"6_months": "6 Monate",
		"1_year": "1 Jahr",
		"this_year": "Laufendes Jahr",
		"soon": "bald",
		"x_min": "[0] min",
		"x_min_ago": "Vor [0] Minuten",
		"x_hours": "[0] Stunden",
		"x_hours_ago": "Vor [0] Stunden",
		"x_days": "[0] Tage",
		"x_days_ago": "Vor [0] Tagen",
		"in_x_min": "in [0] Min",
		"in_x_hour": "in [0] Stunden",
		"today_at": "heute um [0]",
		"tomorrow_at": "morgen um [0]",
		"in_x_days": "in [0] Tagen",
		"in_1_hour_x_min": "in 1 Stunde und [0] Min",
		"in_x_hours_y_min": "in [0] Stunden und [1] Min",
		"total_pagination": "Gesamt: [0]",
		"business_is_subscribed": "Unternehmen bereits abonniert",
		"restaurant": "Restaurant",
		"bar": "Bar oder Kneipe",
		"beach": "Resort-Strand",
		"other": "Andere",
		"ok": "OK",
		"copy": "Kopieren",
		"apply": "Anwenden",
		"back": "Zurück",
		"items_per_page": "Objekte pro Seite",
		"next": "Nächste",
		"success": "Erfolg",
		"operation_completed": "Vorgang abgeschlossen",
		"action": "Aktion",
		"error": "Fehler",
		"room": "Sala",
		"warning": "Warnung",
		"no_result": "Kein Ergebnis",
		"total_x": "Gesamt: [0]",
		"missing_data": "Keine Daten verfügbar.",
		"allergens_celery": "Sellerie",
		"allergens_clams": "Muscheln",
		"allergens_dioxide": "Sulfite",
		"allergens_egg": "Ei",
		"allergens_fish": "Fisch",
		"allergens_lupins": "Lupinen",
		"allergens_gluten": "Gluten",
		"allergens_milk": "Milch",
		"allergens_mustard": "Senf",
		"allergens_peanuts": "Erdnüsse",
		"allergens_sesame": "Sesam",
		"allergens_shellfish": "Schaltier",
		"allergens_soia": "Soja",
		"allergens_wot": "Nüsse",
		"allergens_almond": "Mandeln",
		"allergens_barley": "Gerste",
		"allergens_brazil_nuts": "Brasilianische Nüsse",
		"allergens_cashew": "Cashew",
		"allergens_hazelnuts": "Haselnüsse",
		"allergens_macadamia": "Macadamia",
		"allergens_oats": "Hafer",
		"allergens_pecan": "Pekannuss",
		"allergens_pistachios": "Pistazien",
		"allergens_rye": "Roggen",
		"allergens_spelt": "Dinkel",
		"allergens_walnuts": "Walnüsse",
		"allergens_wheat": "Weizen",
		"allergens_alcohol": "Alkohol",
		"allergens_halal": "Halal",
		"allergens_kosher": "Koscher",
		"allergens_vegan": "Vegan",
		"allergens_vegetarian": "Vegetarier",
		"allergens_no_allergens": "Keine Allergene",
		"allergens_gluten_free": "Glutenfrei",
		"allergens_kamut": "Kamut",
		"try_later_error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.",
		"saved": "Gerettet",
		"changes_saved": "Änderungen erfolgreich gespeichert",
		"no": "NEIN",
		"yes": "Ja"
	}
}